import { Row } from 'farmhub-ui-core';
import styled, { css } from 'styled-components';

export const WrapperDesktop = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  justify-content: space-between;
  padding: 12px ${props => `${props.theme.app.padding.horizontal}`};
  margin-bottom: 12px;
  border: 1px solid ${props => props.theme.colors.border.main};

  cursor: pointer;

  transition: all 0.4s;

  position: relative;

  &:hover {
    border-color: ${props => props.theme.colors.primary.main};

    &::before {
      content: ' ';
      width: 100%;
      height: 100%;
      border-radius: 12px;
      background: ${props => props.theme.colors.primary.main};

      opacity: 0.1;
      pointer-events: auto;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;

export const InfoCardDesktop = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding-right: 24px;
`;

export const ImgWrapperDesktop = styled.div`
  position: relative;
`;

export const ImgDesktop = styled.img`
  width: ${props => props.theme.avatar.size.lg}px;
  height: ${props => props.theme.avatar.size.lg}px;
  box-sizing: border-box;
  border-radius: 50%;
  object-fit: cover;
`;

export const TextWrapperDesktop = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  cursor: pointer;
`;

export const EntityTypeIconStylesDesktop = css`
  background: #fafafa;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.colors.primary.main};
  position: absolute;
  right: 0px;
  bottom: 8px;
  transform: translate(30%, 30%);

  svg {
    width: 14px;
    height: 14px;
  }
`;

export const DomainWrapperDesktop = styled(Row)`
  .check-out-line {
    svg {
      fill: ${p => p.theme.colors.success};
    }
  }

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const WrapperMobile = styled.div`
  width: 100%;
  padding: ${props => props.theme.app.padding.vertical} 0px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  // background-color: #fafafa;
  border-bottom: 1px solid ${props => props.theme.colors.border.light};

  cursor: pointer;
  transition: all 0.4s;
`;

export const InfoCardMobile = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding-right: 24px;
`;

export const ImgWrapperMobile = styled.div`
  position: relative;
`;

export const ImgMobile = styled.img`
  width: ${props => props.theme.avatar.size.md}px;
  height: ${props => props.theme.avatar.size.md}px;
  box-sizing: border-box;
  border-radius: 50%;
  object-fit: cover;
`;

export const TextWrapperMobile = styled.div`
  width: 200px;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin-left: 12px;
  cursor: pointer;
`;

export const NotificationWrapperMobile = styled.div`
  width: auto;
  display: flex;
  align-items: center;
`;

export const EntityTypeIconStylesMobile = css`
  background: #fafafa;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.colors.primary.main};
  position: absolute;
  right: 0px;
  bottom: 8px;
  transform: translate(30%, 30%);

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 14px;
    height: 14px;
  }
`;
